import script from "./OfferInquiry.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferInquiry.vue?vue&type=script&setup=true&lang=js"

import "./OfferInquiry.vue?vue&type=style&index=0&id=51b9be9a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b9be9a"]])

export default __exports__